import { render, staticRenderFns } from "./StudioPurchaseToolbar.vue?vue&type=template&id=18bafc5c&scoped=true&"
import script from "./StudioPurchaseToolbar.vue?vue&type=script&lang=js&"
export * from "./StudioPurchaseToolbar.vue?vue&type=script&lang=js&"
import style0 from "./StudioPurchaseToolbar.vue?vue&type=style&index=0&id=18bafc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bafc5c",
  null
  
)

export default component.exports